import React from 'react';
import FlightFilters from '../components/flights/FlightFilters';
import FlightsTable from '../components/flights/FlightsTable';
import UserHeader from '../components/UserHeader';
import { FlightFilterProvider } from '../contexts/FlightFilterContext';

const Flights: React.FC = () => {
  return (
    <FlightFilterProvider>
      <div className="container" style={{ padding: '40px' }}>
        <UserHeader title="Meine Flüge" />
        <FlightFilters />
        <FlightsTable />
      </div>
    </FlightFilterProvider>
  );
};

export default Flights;
